var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('t-dynamic-component',{attrs:{"module":_vm.schema.module,"value":_vm.schema.id,"props":{ schema: _vm.schema, data: _vm.data }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }